import type { CompareTopic } from "@/mocks/compare";

export default function CompareCard({ topic, priority = false }: { topic: CompareTopic; priority?: boolean }) {
  const [sa, sb] = topic.subjects;
  return (
    <article className="flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50">
      <div className="border-b border-background-200 p-5 md:p-6">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">{topic.tag}</span>
          <span className="flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-scales-3-line"></i> 同台对比
          </span>
        </div>
        <h3 className={`mt-3 font-semibold text-foreground-950 ${priority ? "text-xl md:text-2xl" : "text-lg"}`}>
          {topic.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-500">{topic.question}</p>

        <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <div className="flex items-center gap-3 rounded-xl bg-background-100 p-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className={sa.icon}></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{sa.name}</p>
              <p className="text-xs text-foreground-500">{sa.desc}</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-xl bg-background-100 p-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className={sb.icon}></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{sb.name}</p>
              <p className="text-xs text-foreground-500">{sb.desc}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 p-5 md:p-6">
        <ul className="divide-y divide-background-200">
          {topic.rows.map((r) => (
            <li key={r.label} className="grid grid-cols-1 gap-1 py-3 sm:grid-cols-12 sm:items-center sm:gap-3">
              <span className="text-xs font-medium text-foreground-500 sm:col-span-2">{r.label}</span>
              <span className="text-sm text-foreground-800 sm:col-span-5">{r.a}</span>
              <span className="hidden text-xs text-secondary-600 sm:block sm:col-span-1">
                <i className="ri-swap-2-fill"></i>
              </span>
              <span className="text-sm text-foreground-800 sm:col-span-4">{r.b}</span>
            </li>
          ))}
        </ul>
        <div className="mt-3 rounded-xl bg-accent-50 p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-accent-700">小结</p>
          <p className="mt-1.5 text-sm leading-6 text-foreground-800">{topic.verdict}</p>
        </div>
      </div>
    </article>
  );
}